//# sourceMappingURL=qualification_matrix.mjs.map
/// <reference types="./qualification_matrix.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $decrypt from "../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class QualificationMatrix extends $CustomType {
  constructor(id, title, content, qm_order, org_id) {
    super();
    this.id = id;
    this.title = title;
    this.content = content;
    this.qm_order = qm_order;
    this.org_id = org_id;
  }
}
export const QualificationMatrix$QualificationMatrix = (id, title, content, qm_order, org_id) =>
  new QualificationMatrix(id, title, content, qm_order, org_id);
export const QualificationMatrix$isQualificationMatrix = (value) =>
  value instanceof QualificationMatrix;
export const QualificationMatrix$QualificationMatrix$id = (value) => value.id;
export const QualificationMatrix$QualificationMatrix$0 = (value) => value.id;
export const QualificationMatrix$QualificationMatrix$title = (value) =>
  value.title;
export const QualificationMatrix$QualificationMatrix$1 = (value) => value.title;
export const QualificationMatrix$QualificationMatrix$content = (value) =>
  value.content;
export const QualificationMatrix$QualificationMatrix$2 = (value) =>
  value.content;
export const QualificationMatrix$QualificationMatrix$qm_order = (value) =>
  value.qm_order;
export const QualificationMatrix$QualificationMatrix$3 = (value) =>
  value.qm_order;
export const QualificationMatrix$QualificationMatrix$org_id = (value) =>
  value.org_id;
export const QualificationMatrix$QualificationMatrix$4 = (value) =>
  value.org_id;

export class NotSelected extends $CustomType {}
export const Answer$NotSelected = () => new NotSelected();
export const Answer$isNotSelected = (value) => value instanceof NotSelected;

export class Yes extends $CustomType {}
export const Answer$Yes = () => new Yes();
export const Answer$isYes = (value) => value instanceof Yes;

export class No extends $CustomType {}
export const Answer$No = () => new No();
export const Answer$isNo = (value) => value instanceof No;

export function decoder() {
  return $decode.field(
    "id",
    $decrypt.uuid(),
    (id) => {
      return $decode.field(
        "title",
        $decode.string,
        (title) => {
          return $decode.field(
            "content",
            $decode.string,
            (content) => {
              return $decode.field(
                "qm_order",
                $decode.int,
                (qm_order) => {
                  return $decode.field(
                    "org_id",
                    $decode.string,
                    (org_id) => {
                      return $decode.success(
                        new QualificationMatrix(
                          id,
                          title,
                          content,
                          qm_order,
                          org_id,
                        ),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function answer_decoder() {
  return $decode.then$(
    $decode.string,
    (content) => {
      if (content === "not-selected") {
        return $decode.success(new NotSelected());
      } else if (content === "yes") {
        return $decode.success(new Yes());
      } else if (content === "no") {
        return $decode.success(new No());
      } else {
        return $decode.failure(new Yes(), "Answer");
      }
    },
  );
}

export function encode(item) {
  return $json.object(
    toList([
      ["id", $json.string(item.id)],
      ["title", $json.string(item.title)],
      ["content", $json.string(item.content)],
      ["qm_order", $json.int(item.qm_order)],
      ["org_id", $json.string(item.org_id)],
    ]),
  );
}

export function encode_answer(answer) {
  if (answer instanceof NotSelected) {
    return $json.string("not-selected");
  } else if (answer instanceof Yes) {
    return $json.string("yes");
  } else {
    return $json.string("no");
  }
}
